import { Col, Image, Row, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { Typography, Button, ResponsiveContainer } from '@sunday/component';
import Layout from '../../components/Layout';
import { config } from '../../config';
import style from './about.module.scss';
import cn from 'classnames';
import { useState } from 'react';

const { ASSET_PREFIX } = config;
export const AboutPageNameSpace = ['page.about'];

const PeopleCard = ({ src, name, position, description}: any) => {
  const [open, setOpen] = useState<boolean>(false);
  const onOpen = () => {
   setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className={style.person} onClick={onOpen}>
        <Image
          style={{ height: '310px', width: 'auto' }}
          src={src}
          preview={false}
          alt={name}
        />
        <div className={style.name}>
          <Typography.Body designLevel={2} weight='bold' >
            {name}
          </Typography.Body>
          <Typography.Body designLevel={2} >
            {position}
          </Typography.Body>
        </div>
      </div>
      <Modal
        centered
        open={open}
        closable={false}
        footer={null}
        onCancel={onClose}
        wrapClassName={style.wrappedModal}>
        <div className={style.modal}>
          <div className={style.close}>
            <img
              src={`${ASSET_PREFIX}/static/icon/ic-close.svg`}
              onClick={onClose}
              onKeyDown={(event) => ([' ', '\n'].includes(event.key) ? onClose() : false)}
            />
          </div>
          <div className={style.imgModal}>
            <img src={src} alt={name} />
          </div>
          <div className={style.contentModal}>
            <Typography.Body designLevel={2} weight='bold' >
              {name}
            </Typography.Body>
            <Typography.Body designLevel={2} className={style.secondary}>
              {position}
            </Typography.Body>
            <Typography.Body designLevel={2} className={style.modalDescription}>
              {description}
            </Typography.Body>
          </div>
        </div>
      </Modal>
    </>
  );
};

const About = () => {
  const { t  } = useTranslation(AboutPageNameSpace);
  return (
    <Layout>
      <Row align='middle' gutter={24} className={style.heroBanner}>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
        <Col xs={{ span: 20, offset: 2 }} sm={{ span: 10, offset: 4 }} lg={0} >
          <Typography.Display designLevel={3} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span> {t('tag-3')}
          </Typography.Display>
        </Col>
        <Col xs={0} sm={0} lg={{ span: 10, offset: 4 }} >
          <Typography.Display designLevel={2} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span> {t('tag-3')}
          </Typography.Display>
        </Col>
        <Col xs={24} sm={{ span: 6 }} lg={8} style={{ textAlign: 'center' }}>
          <Image
            src={`${ASSET_PREFIX}/static/img/img-about-banner.svg`}
            preview={false}
            alt="hero-banner"
          />
        </Col>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
      </Row>

      <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
        <ResponsiveContainer>
          <Row className={style.about} align={"middle"} style={{ whiteSpace: "pre-line", margin: "32px 0"}}>
            <Col xl={{ span: 8, offset: 1 }} xs={24}>
              <Image
                src={`${ASSET_PREFIX}/static/img/img-ice-cream.svg`}
                preview={false}
                alt="about"
                />
            </Col>
            <Col xl={15} xs={24}>
              <Typography.Title designLevel={3} className={style.secondary}>
                {t('about')}
              </Typography.Title>
            </Col>
          </Row>
        </ResponsiveContainer>
      </div>

      <Row className={style.howItBegins}>
        <ResponsiveContainer>
          <Row gutter={16}>
            <Col xs={24} lg={12} className={style.column}>
              <Row>
                <Col xs={0} xl={24}>
                  <Typography.Display designLevel={3} weight='bold'>
                    {t('how-it-begins')}
                  </Typography.Display>
                </Col>
                <Col xs={24} xl={0} style={{ textAlign: "center" }}>
                  <Typography.Headline designLevel={1} weight='bold'>
                    {t('how-it-begins')}
                  </Typography.Headline>
                </Col>
              </Row>
              <Row>
                <Col xs={0} xl={24} style={{ paddingRight: "24px" }}>
                  <Typography.Title designLevel={3} className={style.secondary}>
                    {t('how-it-begins-1')}
                  </Typography.Title>
                </Col>
                <Col xs={24} xl={0}>
                  <Typography.Title designLevel={3} className={style.secondary}>
                    {t('how-it-begins-1')}
                  </Typography.Title>
                </Col>
              </Row>
            </Col>
            <Col xs={24} lg={12} className={style.left}>
              <Image
                src={`${ASSET_PREFIX}/static/img/img-how-it-begins.svg`}
                preview={false}
                alt="how-it-begins"
              />
            </Col>
          </Row>
          <Row style={{ flexDirection: 'row-reverse', marginTop: '32px' }}>
            <Col xs={24} lg={12} className={style.howItBegins2}>
              <Typography.Title designLevel={3} className={style.secondary}>
                {t('how-it-begins-2')}
              </Typography.Title>
            </Col>
            <Col xs={24} lg={12} className={style.right}>
              <Image
                src={`${ASSET_PREFIX}/static/img/img-how-it-begins-2.svg`}
                preview={false}
                alt="how-it-begins-2"
                />
            </Col>
          </Row>
        </ResponsiveContainer>
      </Row>
      <Row className={style.team} align='middle'>
        <ResponsiveContainer>
          <Row>
            <Col xs={0} xl={24}>
              <Typography.Display designLevel={3} weight='bold' >
                {t('board-of-commissioners')}
              </Typography.Display>
            </Col>
            <Col xs={24} xl={0}>
              <Typography.Headline designLevel={1} weight='bold' >
                {t('board-of-commissioners')}
              </Typography.Headline>
            </Col>
          </Row>
          <div className={style.team}>
            <PeopleCard
              src={`${ASSET_PREFIX}/static/img/romiadi.png`}
              name={t('people.romiadi.name')}
              position={t('people.romiadi.position')}
              description={t('people.romiadi.description')}
            />
            <PeopleCard
              src={`${ASSET_PREFIX}/static/img/irma.png`}
              name={t('people.irma.name')}
              position={t('people.irma.position')}
              description={t('people.irma.description')}
            />
          </div>
          <Row>
            <Col xs={0} xl={24}>
              <Typography.Display designLevel={3} weight='bold' >
                {t('board-of-directors')}
              </Typography.Display>
            </Col>
            <Col xs={24} xl={0}>
              <Typography.Headline designLevel={1} weight='bold' >
                {t('board-of-directors')}
              </Typography.Headline>
            </Col>
          </Row>
          <div className={style.team}>
            <PeopleCard
              src={`${ASSET_PREFIX}/static/img/erwin.png`}
              name={t('people.erwin.name')}
              position={t('people.erwin.position')}
              description={t('people.erwin.description')}
            />
            <PeopleCard
              src={`${ASSET_PREFIX}/static/img/ivan.png`}
              name={t('people.ivan.name')}
              position={t('people.ivan.position')}
              description={t('people.ivan.description')}
            />
          </div>
        </ResponsiveContainer>
      </Row>
      {
      /*
      <Row className={style.company}>
        <ResponsiveContainer>
          <Row align='middle' gutter={24} style={{ display: 'flex', justifyContent: 'center'}}>
            <Typography.Headline designLevel={1} weight='bold'>
              {t('company-info.title')}
            </Typography.Headline>
          </Row>
          <Row align='middle' gutter={24}>
            <Col xs={24} lg={12} className={style.column}>
              <Typography.Body designLevel={2} weight={'bold'}>
                {t('company-info.name.title')}
              </Typography.Body>
              <Typography.Body designLevel={2} className={style.body}>
                {t('company-info.name.body')}
              </Typography.Body>
              <Typography.Body designLevel={2} weight={'bold'}>
                {t('company-info.address.title')}
              </Typography.Body>
              <Typography.Body designLevel={2} className={style.body}>
                {t('company-info.address.body')}
              </Typography.Body>
              <Typography.Body designLevel={2} weight={'bold'}>
                {t('company-info.certificate.title')}
              </Typography.Body>
              <Typography.Body designLevel={2} className={style.body}>
                {t('company-info.certificate.body')}
              </Typography.Body>
              <Typography.Body designLevel={2} weight={'bold'}>
                {t('company-info.certificate-amendment.title')}
              </Typography.Body>
              <Typography.Body designLevel={2} className={style.body}>
                {t('company-info.certificate-amendment.body')}
              </Typography.Body>
            </Col>
            <Col xs={24} lg={12} className={style.column}>
              <Typography.Body designLevel={2} weight={'bold'}>
                {t('company-info.license.title')}
              </Typography.Body>
              <Typography.Body designLevel={2} className={style.body}>
                {t('company-info.license.body')}
              </Typography.Body>
              <Typography.Body designLevel={2} weight={'bold'}>
                {t('company-info.bank.title')}
              </Typography.Body>
              <Typography.Body designLevel={2} className={style.body}>
                {t('company-info.bank.body')}
              </Typography.Body>
              <Typography.Body designLevel={2} weight={'bold'}>
                {t('company-info.approval.title')}
              </Typography.Body>
              <Typography.Body designLevel={2} className={style.body}>
                {t('company-info.approval.body')}
              </Typography.Body>
            </Col>
          </Row>
        </ResponsiveContainer>
      </Row>
      */
      }
    </Layout>
  );
};

export default About;
